import { CARD_PRODUCT, PERSONAL_CHECKING_ACCOUNT, PERSONAL_SAVINGS_ACCOUNT } from '@americanexpress/product-ducks';

const productTypeRoutes = new Map();
productTypeRoutes.set(CARD_PRODUCT, '/dashboard');
productTypeRoutes.set(PERSONAL_CHECKING_ACCOUNT, '/banking/dashboard');
productTypeRoutes.set(PERSONAL_SAVINGS_ACCOUNT, '/en-us/account/document-center');

const sharedRoutes = [
  '/overview',
  '/address',
  '/email',
  '/account-management/phone',
  '/en-us/account/document-center',
];
const supportRoutes = [
  '/search',
  '/faq',
  '/contact-us',
  '/financial-relief',
  '/enrollments',
];
const sharedRouteChecks = [
  new RegExp(sharedRoutes.join('|')),
  /\/demo\/.+/,
];
const supportRouteChecks = [
  new RegExp(supportRoutes.join('|')),
  /^(\/[^/]{5})?\/help/, // e.g. en-US, en-GB
];

export {
  productTypeRoutes,
  sharedRouteChecks,
  supportRouteChecks,
};
